export const DateOfDeathContent = {
  errorMsg: 'Your entry is invalid.',
  dodLabel: 'Date of death (mm/dd/yyyy)',
};
